module.exports = __webpack_public_path__ + "static/media/merch.58c1f173.JPG";